import { useEffect, useState } from 'react';
import AuthenticationAPI from 'lib/auth/authentication';
import { isApiConnectionError } from 'lib/api/apiClientLifecycle';
import { emitServerUnreachable } from 'v5/platform/server-unreachable/serverUnreachableEvent';

/**
 * Fetch tenant and their enabled authentication methods
 * @param [initialState=null]
 * @returns {Object}
 */
const useFetchAuthMethods = (initialState = null) => {
  const [methods, setMethods] = useState(initialState);

  useEffect(() => {
    async function fetch() {
      try {
        const methods = await AuthenticationAPI.getTenantAuthMethods();
        setMethods(methods);
      } catch (err) {
        console.error(err);
        if (isApiConnectionError(err)) {
          emitServerUnreachable(err, 'sign_in');
        }
      }
    }
    fetch();
  }, []);

  return methods;
};

export default useFetchAuthMethods;
